import { render, staticRenderFns } from "./DetalhamentoChecklist.vue?vue&type=template&id=3f94f136"
import script from "./DetalhamentoChecklist.vue?vue&type=script&lang=js"
export * from "./DetalhamentoChecklist.vue?vue&type=script&lang=js"
import style0 from "./DetalhamentoChecklist.vue?vue&type=style&index=0&id=3f94f136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports